////////////////////////////////////////////////////////////////
// Description:
// Speed RUM Monitoting Framework
// to caclulate RUM metrics and report back to our servers.
// Through this script we calculate Speed Index for real users
// (rupex) and report it for analysis.
//
// Author:
// Sembian Mani (smani@move.com)
//
// Usage:
// 1. Include the script file in your HTML
// 2. Add ATF and meaningful paint markers
// 3. Run SpeedRUMModule.init()
///////////////////////////////////////////////////////////////

/* global newrelic */

window.SpeedRUMModule = (function(){
  //PRIVATE VARIABLES
  //Speed Gauge to collect all the metrics to monitor
  var speedGaugeObj={};
  //Custom metrics defined by application team
  var customSelectors=["first-meaningful-paint", "above-the-fold"];
  //Performance API
  var perfAPI = window.performance;
  //If performance API is not present return right away
  if(!perfAPI){
    return;
  }
  var perfData = window.performance.timing;

  //PRIVATE FUNCTIONS
  //Gathering perf data from the following channels:
  //1. Navigation Timing API
  //2. Paint Timing API
  //3. User Timing API
  //4. Resource Timing API

  //Gathering user centric nav timing data
  function gatherNavTimingMetrics(){
    //Time to first byte
    speedGaugeObj.ttfb = perfData.responseStart - perfData.navigationStart;
    //Page Load Time Measured until load start (to acomodate data sent to beacon)
    speedGaugeObj.plt = perfData.loadEventStart - perfData.navigationStart;
  }
  //Gathering user centric paint timing data
  function gatherPaintTimingMetrics(){
    let paintMetrics = perfAPI.getEntriesByType("paint");
    if(paintMetrics !== undefined && paintMetrics.length > 0){
      paintMetrics.forEach((paintMetric) => {
        if(paintMetric.name == "first-paint"){
          //Time to first paint
          speedGaugeObj.ttfp = Math.round(paintMetric.startTime);
        }
        if(paintMetric.name == "first-contentful-paint"){
          //Time to first contentful paint
          speedGaugeObj.ttfcp = Math.round(paintMetric.startTime);
        }
      });
    }
  }
  //Gathering user centric nav timing data
  function gatherSecondaryNavTimingMetrics(){
    //DNS Lookup Time
    speedGaugeObj.dns = perfData.domainLookupEnd - perfData.domainLookupStart;
    //TCP Connect Time
    speedGaugeObj.tcpconnect = perfData.connectEnd - perfData.connectStart;
    //SSL Time
    speedGaugeObj.ssl = perfData.secureConnectionStart ? perfData.connectEnd - perfData.secureConnectionStart : 0;
    //Cache lookmup time
    speedGaugeObj.cachelookup = perfData.domainLookupStart - perfData.fetchStart;
    //Redirect lookup time
    speedGaugeObj.redirectlookup = perfData.fetchStart - perfData.navigationStart;
    //Unload time
    speedGaugeObj.unload = perfData.unloadEventEnd - perfData.unloadEventStart;
  }
  //Gathering user centric custom (User) timing data
  function gatherCustomTimingData(){
    var marks = performance.getEntriesByType("mark");
    marks.forEach((mark) => {
      if(mark.name == customSelectors[0]){
        speedGaugeObj.ttfmp = Math.round(mark.startTime);
      }
      if(mark.name == customSelectors[1]){
        speedGaugeObj.atf = Math.round(mark.startTime);
      }
    });
  }
  //RUPEX:  *R*eal *U*ser *P*erformance Ind*ex*
  //5 key metrics that are included and their Visual Completion values:
  //1. TTFB: Time to first byte: 20%
  //2. TTFCP: Time to first contentful paint: 40%
  //3. TTFMP: Time to first meaningful paint: 60%
  //4. ATF:Above The Fold: 80%
  //5. PLT: Page Load Time: 100%
  //Refer: https://docs.google.com/presentation/d/1N1iOw511vuuaGGdVYe897mWcyRNTbdSBggQzRgKtdJM/edit#slide=id.g4071ba6792_0_6
  function calculateRUPEX(){
    //Calculated with equal constant Visual Completion percentage
    speedGaugeObj.rupex = Math.round(speedGaugeObj.ttfb +
                          0.8*(speedGaugeObj.ttfp-speedGaugeObj.ttfb) +
                          0.6*(speedGaugeObj.ttfmp-speedGaugeObj.ttfp) +
                          0.4*(speedGaugeObj.atf-speedGaugeObj.ttfmp) +
                          0.2*(speedGaugeObj.plt-speedGaugeObj.atf));
  }

  //Setup SPA Tracking for RUPEX
  function initSPATracking() {
    //Setting up Event Publisher
    window.publishEvent = function(e_name){
     var event;
     if(typeof Event === "function"){
       event = new Event(e_name)
     }
     else{
       event = document.createEvent("Event");
       event.initEvent(e_name, true, true);
     }
     window.dispatchEvent(event);
    };
    //Whenever there is a SPA navigation, initialise timers and attach listener for spa dom ready.
    window.addEventListener('spa-navstart', function() {
      clearMetrics();
      speedGaugeObj.isSPAData = 1;
      speedGaugeObj.spaNavStart = new Date().getTime();
      window.addEventListener('spa-domready', handleSPADOMReady);
    });
  }
  //After SPA Navigation when the DOM is ready (Component updated) add ATF image handlers,
  function handleSPADOMReady() {
    var atfImages = document.querySelectorAll('[data-atf="true"]');
    var atfLength = atfImages.length;
    //If ATF data attribute is not yet set return back
    if (atfLength == 0) {
      return;
    }
    var atfLoadedCount = 0;
    //Remove event listener so that it is invoked only once per SPA navigation
    window.removeEventListener('spa-domready', handleSPADOMReady);
    //Record DOM Ready timestamp
    speedGaugeObj.spaDomReady = new Date().getTime();
    //Gather ATF images
    var incCount = function() {
      atfLoadedCount++;
      if (atfLoadedCount == atfLength) {
        gatherSPAMetrics();
      }
    };
    //Iterate to check if already loaded. If not attach handler.
    for (var i = 0; i < atfLength; i++) {
      if (atfImages[i].complete) {
        incCount();
      } else {
        atfImages[i].addEventListener('load', incCount);
      }
    }
  }
  //Collect and send all SPA metrics after ATF images are loaded.
  function gatherSPAMetrics() {
    speedGaugeObj.ttfb = 0;
    speedGaugeObj.ttfp = 0;
    speedGaugeObj.ttfcp = 0;
    gatherCustomTimingData();
    speedGaugeObj.ttfmp = speedGaugeObj.ttfmp - (speedGaugeObj.spaNavStart - perfData.navigationStart);
    //If meaningful paint marker is negative, it means the image was already load complete and no new mark was created.
    //In that case we assign spa dom ready to ttfmp.
    if (speedGaugeObj.ttfmp < 0) {
      speedGaugeObj.ttfmp = speedGaugeObj.spaDomReady - speedGaugeObj.spaNavStart;
    }
    //Assign SPA ATF whenever the current function is called.
    speedGaugeObj.atf = new Date().getTime() - speedGaugeObj.spaNavStart;
    speedGaugeObj.plt = speedGaugeObj.atf;
    calculateRUPEX();
    setMetrics();
    if (typeof newrelic !== 'undefined') {
      newrelic.addPageAction('SPA Page Load');
    }
  }


  //Main method to gather data
  function main(){
    gatherNavTimingMetrics();
    gatherPaintTimingMetrics();
    gatherCustomTimingData();
    calculateRUPEX();
    gatherSecondaryNavTimingMetrics();
    setMetrics();
    initSPATracking();
  }
  //Send collected metrics to 3rd party tracking (NewRelic)
  function setMetrics(){
    if(typeof(newrelic) !== 'undefined'){
      newrelic.setCustomAttribute("rdc-appname", "BASECAMP");
      newrelic.setCustomAttribute("rdc-ttfb", speedGaugeObj.ttfb);
      newrelic.setCustomAttribute("rdc-ttfp", speedGaugeObj.ttfp);
      newrelic.setCustomAttribute("rdc-ttfcp", speedGaugeObj.ttfcp);
      newrelic.setCustomAttribute("rdc-ttfmp", speedGaugeObj.ttfmp);
      newrelic.setCustomAttribute("rdc-atf", speedGaugeObj.atf);
      newrelic.setCustomAttribute("rdc-plt", speedGaugeObj.plt);
      newrelic.setCustomAttribute("rdc-rupex", speedGaugeObj.rupex);
      newrelic.setCustomAttribute("rdc-dns", speedGaugeObj.dns);
      newrelic.setCustomAttribute("rdc-tcpconnect", speedGaugeObj.tcpconnect);
      newrelic.setCustomAttribute("rdc-ssl", speedGaugeObj.ssl);
      newrelic.setCustomAttribute("rdc-cachelookup", speedGaugeObj.cachelookup);
      newrelic.setCustomAttribute("rdc-redirectlookup", speedGaugeObj.redirectlookup);
      newrelic.setCustomAttribute("rdc-unload", speedGaugeObj.unload);
    }
  }
  //Clear NewRelic Gauge after API call is made.
  function clearMetrics(){
    if(typeof(newrelic) !== 'undefined'){
      newrelic.setCustomAttribute("rdc-ttfb", null);
      newrelic.setCustomAttribute("rdc-ttfp", null);
      newrelic.setCustomAttribute("rdc-ttfcp", null);
      newrelic.setCustomAttribute("rdc-ttfmp", null);
      newrelic.setCustomAttribute("rdc-atf", null);
      newrelic.setCustomAttribute("rdc-plt", null);
      newrelic.setCustomAttribute("rdc-rupex", null);
      newrelic.setCustomAttribute("rdc-dns", null);
      newrelic.setCustomAttribute("rdc-tcpconnect", null);
      newrelic.setCustomAttribute("rdc-ssl", null);
      newrelic.setCustomAttribute("rdc-cachelookup", null);
      newrelic.setCustomAttribute("rdc-redirectlookup", null);
      newrelic.setCustomAttribute("rdc-unload", null);
    }
  }
  //Exposed functions to access the SpeedGauge.
  return {
    getMetric: function(metric_name){
      //Access collected data from outside the module.
      return speedGaugeObj[metric_name];
    },
    setMetric: function(metric_name, value){
      //Modify Gauge data from outside the module.
      speedGaugeObj[metric_name]=value;
    },
    markAs: function(){
      if(perfAPI){
        for(let i=0; i<arguments.length; i++){
          perfAPI.mark(arguments[i])
        }
      }
      gatherCustomTimingData();
      calculateRUPEX();
      setMetrics();
    },
    clearMetrics : function(){
      clearMetrics();
    },
    setMetrics : function(){
      setMetrics();
    },
    init: function(){
      main();
    }
  }
})();
window.addEventListener('load', function(){SpeedRUMModule.init(); window.markAs = SpeedRUMModule.markAs;})



// WEBPACK FOOTER //
// ./shared_critical/speedrum.js